import { RollbackOutlined } from '@ant-design/icons'
import { Button, Result } from 'antd'
import React, { memo } from 'react'
import { useNavigate } from 'react-router'

export const ErrorPage = memo(function () {
  const navigate = useNavigate()

  return (
    <Result
      status='404'
      title='404'
      subTitle='Sorry, the page you visited does not exist.'
      extra={
        <Button type='primary' icon={<RollbackOutlined />} onClick={() => navigate('/')}>
          Back Home
        </Button>
      }
    />
  )
})
